export const updateOrganizationApiHandler = {
  method: "PATCH",
  path: () => `organizations-dashboard`
};